/**
 * PRP-IMPORT-PRICENOTE-1 web client: the signed-in user's price note list, and marking
 * lines of a stored parse with one.
 *
 * Contract: app/api/routes/price_notes.py. Failures arrive as `ApiError` (message = the
 * backend `detail`, a plain sentence for the user).
 */
import { api } from './api';
import { baseVersion } from './estimateChanged';
import type { ParsedEstimateResponse } from '../types';

/** One line of a stored parse, by position. */
export interface PriceNoteLine {
  room_index: number;
  line_item_index: number;
}

export const PriceNotesAPI = {
  list: (): Promise<{ notes: string[] }> => api.get('/me/price-notes'),

  add: (text: string): Promise<{ notes: string[] }> => api.post('/me/price-notes', { text }),

  remove: (text: string): Promise<{ notes: string[] }> =>
    api.delete('/me/price-notes', { data: { text } }),

  /** Marks lines with `priceNote`; an empty string removes the note. */
  mark: (
    parseHash: string,
    lines: PriceNoteLine[],
    priceNote: string,
  ): Promise<ParsedEstimateResponse> =>
    api.patch(`/completeness/parse/${encodeURIComponent(parseHash)}/price-note`, {
      lines,
      price_note: priceNote,
      ...baseVersion(parseHash),
    }),
};
